import { useSelector } from 'react-redux';
import Gap from 'src/components/atoms/Gap';
import { Line } from 'src/components/atoms/Line';
import { Pagination } from 'src/components/molecules/Pagination';
import useProperty from 'src/features/property/hooks/useProperty';
import { selectors as propertySelectors } from 'src/features/property/propertySlice';
import { StyledPaginationContainer } from './styles';

const DocumentLinkPagination: React.FC = () => {
  const { onGetDocumentListProperties } = useProperty();

  const getPropertiesData = useSelector(propertySelectors.documentLinkListProperties.data);
  const getPropertiesError = useSelector(propertySelectors.documentLinkListProperties.error);
  const getPropertiesFilter = useSelector(propertySelectors.documentLinkListProperties.filter);
  const getPropertiesCount = useSelector(propertySelectors.documentLinkListProperties.count);

  if (getPropertiesError) return null;
  if (!getPropertiesData?.length) return null;

  return (
    <StyledPaginationContainer direction="column">
      <Line height="tiny" />
      <Gap height={1} />
      <Pagination
        name="DocumentLinkPagination"
        rowsPerPage={[5, 10, 20, 50, 100, 250, 500]}
        listPosition="top"
        pageInit={getPropertiesFilter.page}
        rowsPerPageInit={getPropertiesFilter.rowsPerPage || 5}
        totalRows={getPropertiesCount}
        onNext={(page, rowsPerPage) => onGetDocumentListProperties(page, rowsPerPage)}
        onPrev={(page, rowsPerPage) => onGetDocumentListProperties(page, rowsPerPage)}
        onRowsPerPage={(page, rowsPerPage) => onGetDocumentListProperties(page, rowsPerPage)}
      />
    </StyledPaginationContainer>
  );
};

export default DocumentLinkPagination;
